import React from "react";

export const Header = () =>{
    return (
        <div className="Header">
            <h1>NC Games</h1>
        </div>
    )
}